import { toast } from 'react-toastify'

export const openSuccessToaster = ({ message, toasterId = '' }) => {
  toast.success(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: false,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openErrorToaster = ({ message = '', toasterId = '' } = {}) => {
  toast.error(message, {
    position: 'bottom-right',
    autoClose: 7000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: false,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openInfoToaster = ({ message, toasterId = '' }) => {
  toast.info(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: false,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}

export const openWarningToaster = ({ message, toasterId = '' }) => {
  toast.warn(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: false,
    theme: 'colored',
    toastId: `${message}${toasterId}`
  })
}
